import {
  EnterpriseDeployJob,
  enterpriseAcceptancePassed,
} from './enterpriseDeployShared';

/** When true, Setup home blocks staged config until enterprise acceptance passes. */
export function requireEnterpriseAcceptanceForSetup(): boolean {
  const raw = String(
    process.env.REACT_APP_REQUIRE_ENTERPRISE_ACCEPTANCE_FOR_SETUP ?? 'true',
  )
    .trim()
    .toLowerCase();
  return raw !== '0' && raw !== 'false' && raw !== 'no' && raw !== 'off';
}

export function enterpriseProductionReady(
  job: EnterpriseDeployJob | null | undefined,
): boolean {
  if (job?.validation?.ready_for_production === true) return true;
  return enterpriseAcceptancePassed(job);
}

export function setupProductionGateBlocked(
  job: EnterpriseDeployJob | null | undefined,
  canReadDeployments: boolean,
): boolean {
  if (!requireEnterpriseAcceptanceForSetup()) return false;
  if (!canReadDeployments) return false;
  return !enterpriseProductionReady(job);
}

export function productionReadyChipLabel(
  job: EnterpriseDeployJob | null | undefined,
): string {
  if (enterpriseProductionReady(job)) return 'Production ready';
  const st = String(job?.status || '').toLowerCase();
  if (st === 'running' || st === 'in_progress') return 'Prod deploy running';
  if (job?.release_id) return 'Needs prod acceptance';
  return 'Needs production deploy';
}

export function productionReadyChipColor(
  job: EnterpriseDeployJob | null | undefined,
): 'default' | 'success' | 'error' | 'warning' | 'info' {
  if (enterpriseProductionReady(job)) return 'success';
  const st = String(job?.status || '').toLowerCase();
  if (st === 'running' || st === 'in_progress') return 'info';
  if (st === 'error' || st === 'failed') return 'error';
  return 'warning';
}
